import React from 'react';
import { useSelector } from 'react-redux';
import {
  TOTAL_ASKING_PRICE,
  ASKING_PRICE_PER_HECTARE,
  MAKE_AN_OFFER
} from 'helpers/constant';
const ListingDetailsMain = () => {
  const { title, price, pricingOption } = useSelector(
    state => state.viewListing
  );
  return (
    <>
      <h4 className="mb-4">{title}</h4>
      <h5 className="d-flex align-items-center">
        <span className="text-warning me-2">
          <>Asking price: </>
          {pricingOption === MAKE_AN_OFFER ? 'Make an offer' : `$${price}`}
          {pricingOption === TOTAL_ASKING_PRICE && <> per year</>}
          {pricingOption === ASKING_PRICE_PER_HECTARE && (
            <> per hectare per year</>
          )}
        </span>
      </h5>
    </>
  );
};

export default ListingDetailsMain;
